import React from 'react';
import {
  HubModule,
  PropsWithTestId,
  TitleSizeType,
  UploadedFile,
  UploadedImage,
} from '../../../../../../types';
import { HubModuleTypes } from '../../../../../../constants';
import ThumbStylesNone from './ThumbStylesNone';
import ThumbStylesPortrait from './ThumbStylePortrait';
import ThumbStyleLandscape from './ThumbStyleLandscape';
import { HubModuleWrapper } from '../../HubModuleWrapper';

export enum FileDownloadThumbStyles {
  NONE = 'NONE',
  PORTRAIT = 'PORTRAIT',
  LANDSCAPE = 'LANDSCAPE',
}

export interface FileDownloadModuleType extends HubModule {
  '@type': HubModuleTypes.FileDownload;
  ctatext?: string;
  title?: string;
  titleSize?: TitleSizeType;
  text?: string;
  thumbStyle: FileDownloadThumbStyles;
  file: UploadedFile;
  image?: UploadedImage;
}

export interface FileDownloadModuleProps {
  module: FileDownloadModuleType;
}

export default function FileDownloadModule({
  module: {
    '@type': type,
    thumbStyle,
    title,
    titleSize = 'H2',
    text,
    file,
    ctatext,
    image,
    elementId,
    visualStyle,
  },
  testId,
}: PropsWithTestId<FileDownloadModuleProps>) {
  return (
    <HubModuleWrapper
      type={type}
      theme={visualStyle}
      elementId={elementId}
      testId={testId}
    >
      <div className="container">
        {thumbStyle === FileDownloadThumbStyles.NONE && (
          <ThumbStylesNone
            title={title}
            titleSize={titleSize}
            text={text}
            ctatext={ctatext}
            file={file}
          />
        )}
        {thumbStyle === FileDownloadThumbStyles.PORTRAIT && (
          <ThumbStylesPortrait
            title={title}
            titleSize={titleSize}
            text={text}
            ctatext={ctatext}
            file={file}
            image={image}
          />
        )}
        {thumbStyle === FileDownloadThumbStyles.LANDSCAPE && (
          <ThumbStyleLandscape
            title={title}
            titleSize={titleSize}
            text={text}
            ctatext={ctatext}
            file={file}
            image={image}
          />
        )}
      </div>
    </HubModuleWrapper>
  );
}

FileDownloadModule.defaultProps = {
  testId: 'hub-file-download-module',
};
